/*
 * newsbot - Entities section for filter details
 * Match or exclude stories by named entities (people, organizations, locations)
 */

import { useFormikContext } from "formik";
import { CollapsibleSection, FilterLayoutClass, FilterTightGridGapClass } from "@/components/filters/_components";
import { TextAreaAutoResize } from "@/components/inputs/input";
import { Select } from "@/components/inputs/select";
import { classNames } from "@utils";

const matchLogicOptions = [
  { label: "Match ANY entity", value: "ANY" },
  { label: "Match ALL entities", value: "ALL" },
];

interface EntitiesFormValues {
  match_entities: string;
  except_entities: string;
  entities_match_logic: 'ANY' | 'ALL';
  entities_except_logic: 'ANY' | 'ALL';
}

export const Entities = () => {
  const { values } = useFormikContext<EntitiesFormValues>();

  return (
    <CollapsibleSection
      defaultOpen={values.match_entities?.length > 0 || values.except_entities?.length > 0}
      title="Entities"
      subtitle="Match or exclude stories by named entities (people, organizations, locations)"
    >
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="match_entities"
          label="Match entities"
          columns={8}
          placeholder="Elon Musk, Apple Inc, New York"
          tooltip={<p>Comma-separated entity names to match</p>}
        />
        <Select
          name="entities_match_logic"
          label="Match logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="except_entities"
          label="Except entities"
          columns={8}
          placeholder="Spam Corp, Fake Person"
          tooltip={<p>Stories mentioning these entities are excluded</p>}
        />
        <Select
          name="entities_except_logic"
          label="Except logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
    </CollapsibleSection>
  );
};
